import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../services/auth";

export default function RequireAuth() {
    const { status } = useAuth();

    // Render nothing until the answer is known. The session cookie is httpOnly, so
    // "signed in?" can't be answered synchronously any more - redirecting on the
    // not-yet-known state would bounce a signed-in user off their own dashboard on
    // every refresh.
    if (status === "loading") {
        return null;
    }
    if (status === "unauthenticated") {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
}
